module.exports = __webpack_public_path__ + "media/images/recover_data-ba102aaebaabf27d7b34892c33cbf84a.png";